<template>
  <v-row>
    <v-col cols="12" lg="8" class="pa-2 pb-0">
      <div class="d-flex align-center">
        <slot></slot>
      </div>
    </v-col>

    <v-col cols="12" lg="4" class="pa-2 pb-0">
      <div class="d-flex align-center justify-end">
        <v-btn small @click="$emit('recargar')" title="Recargar">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>

        <v-switch
          class="ml-4"
          v-model="ingresos.mostradoDetalle"
          label="Mostrar Detalle"
          :disabled="ingresos.data.length == 0"></v-switch>
      </div>
    </v-col>

    <v-col cols="12" class="pa-2 pb-0">
      <v-progress-linear indeterminate color="purple" class="mb-2" v-if="ingresos.cargando" />

      <ReporteIngresosTabla :estimaciones="ingresos.data" :mostradoDetalle="ingresos.mostradoDetalle" />
    </v-col>
  </v-row>
</template>

<script>
import ReporteIngresosTabla from './ReporteIngresosTabla.vue';

export default {
  name: 'ReporteIngresos',
  components: {
    ReporteIngresosTabla,
  },
  props: {
    ingresos: {
      type: Object,
      required: true,
      validator: (value) => {
        return (
          value.hasOwnProperty('data') && value.hasOwnProperty('cargando') && value.hasOwnProperty('mostradoDetalle')
        );
      },
    },
  },
};
</script>

<style>
</style>